import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { BidStatusEnum, Lot } from 'src/app/modules/graphql/service/graphql-auto-main-service';
import { AuctionData } from 'src/app/modules/graphql/service/graphql-directory-service';
import { normalizeAuctionStartDatetime } from 'src/app/const';

@Injectable()
export class LotWatchRequestTimeLimitService {
  isInspectionAvailable(lot: Lot, auctionData: AuctionData): boolean {
    const now = DateTime.now().setZone('Asia/Tokyo');
    const auctionStart = normalizeAuctionStartDatetime(lot.auctionDatetime);
    const isUserWinner = lot.currentUserLastBid?.status === BidStatusEnum.Won;
    const { inspectionAvailableBeforeHours, inspectionAfterEndUntilTimeJst } = auctionData;
    const inspectionAvailableBeforeStart = this.calculateInspectionAvailableBeforeStart(
      auctionStart,
      inspectionAvailableBeforeHours,
    );
    const inspectionAvailableAfterWin = this.calculateInspectionAvailableAfterWin(
      now,
      auctionStart,
      inspectionAfterEndUntilTimeJst,
    );

    if (isUserWinner) {
      return now < inspectionAvailableAfterWin;
    } else {
      return now < inspectionAvailableBeforeStart;
    }
  }

  private calculateInspectionAvailableBeforeStart(
    auctionStart: DateTime,
    inspectionAvailableBeforeHours: number | null | undefined,
  ): DateTime {
    if (inspectionAvailableBeforeHours) {
      return auctionStart.minus({ hours: inspectionAvailableBeforeHours });
    } else {
      return auctionStart;
    }
  }

  private calculateInspectionAvailableAfterWin(
    now: DateTime,
    auctionStart: DateTime,
    inspectionAfterEndUntilTimeJst: string | null | undefined,
  ): DateTime {
    if (inspectionAfterEndUntilTimeJst) {
      const [hours, minutes] = inspectionAfterEndUntilTimeJst.split(':');
      const inspectionAvailableTo = auctionStart.startOf('minute').set({
        hour: Number(hours),
        minute: Number(minutes),
      });

      if (inspectionAvailableTo <= auctionStart) {
        return inspectionAvailableTo.plus({ day: 1 });
      } else {
        return inspectionAvailableTo;
      }
    } else {
      return now;
    }
  }
}
